import routes from 'global/Constants/routes';
import { lazy } from 'react';

const LoginWithGoogle = lazy(() => import('../../pages/home/loginWithGoogle/LoginWithGoogle'));
const LoginWithPhoneNumber = lazy(() => import('../../pages/login/LoginWithPhoneNumberPage'));

export const loginWithGoogleRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.loginFormWithPhoneNumber.path,
    component: LoginWithPhoneNumber,
    isPrivate: routes.loginFormWithPhoneNumber.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.loginWithGoogle.path,
    component: LoginWithGoogle,
    isPrivate: routes.loginWithGoogle.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
